import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["directPanel", "groupPanel", "groupForm", "selectedMembers", "memberInputs", "submitBtn", "groupGuestList"]

  connect() {
    this.selectedMembers = new Map()
  }

  switchTab(event) {
    const tab = event.target.closest(".new-chat-tab")
    if (!tab) return

    const tabName = tab.dataset.tab

    // Update tab styles
    document.querySelectorAll(".new-chat-tab").forEach(t => t.classList.remove("active"))
    tab.classList.add("active")

    // Show/hide panels
    if (tabName === "direct") {
      this.directPanelTarget.style.display = "block"
      this.groupPanelTarget.style.display = "none"
    } else {
      this.directPanelTarget.style.display = "none"
      this.groupPanelTarget.style.display = "block"
    }
  }

  filterGuests(event) {
    const query = event.target.value.toLowerCase()
    const items = document.querySelectorAll("#guest-list .guest-item")

    items.forEach(item => {
      const name = item.querySelector(".guest-name")?.textContent.toLowerCase() || ""
      if (name.includes(query)) {
        item.style.display = "flex"
      } else {
        item.style.display = "none"
      }
    })
  }

  filterGroupGuests(event) {
    const query = event.target.value.toLowerCase()
    const items = this.groupGuestListTarget.querySelectorAll(".guest-item")

    items.forEach(item => {
      const name = item.querySelector(".guest-name")?.textContent.toLowerCase() || ""
      if (name.includes(query)) {
        item.style.display = "flex"
      } else {
        item.style.display = "none"
      }
    })
  }

  toggleMember(event) {
    const item = event.currentTarget
    const guestId = item.dataset.guestId
    const guestName = item.dataset.guestName

    if (this.selectedMembers.has(guestId)) {
      // Remove
      this.selectedMembers.delete(guestId)
      item.classList.remove("selected")
    } else {
      // Add
      this.selectedMembers.set(guestId, guestName)
      item.classList.add("selected")
    }

    this.updateSelectedDisplay()
    this.updateMemberInputs()
    this.updateSubmitButton()
  }

  updateSelectedDisplay() {
    this.selectedMembersTarget.replaceChildren()

    if (this.selectedMembers.size === 0) {
      const placeholder = document.createElement("span")
      placeholder.style.color = "var(--gp-text-muted)"
      placeholder.style.fontSize = "0.8125rem"
      placeholder.textContent = "Seleciona convidados abaixo"
      this.selectedMembersTarget.append(placeholder)
      return
    }

    this.selectedMembers.forEach((name, id) => {
      const member = document.createElement("span")
      member.className = "selected-member"
      member.dataset.guestId = id
      member.append(document.createTextNode(`${name} `))

      const removeButton = document.createElement("button")
      removeButton.type = "button"
      removeButton.className = "selected-member-remove"
      removeButton.dataset.action = "click->new-chat#removeMember"
      removeButton.textContent = "×"
      member.append(removeButton)
      this.selectedMembersTarget.append(member)
    })
  }

  removeMember(event) {
    event.stopPropagation()
    const memberEl = event.target.closest(".selected-member")
    if (!memberEl) return

    const guestId = memberEl.dataset.guestId
    this.selectedMembers.delete(guestId)

    // Also unselect in the list
    const listItem = this.groupGuestListTarget.querySelector(`[data-guest-id="${guestId}"]`)
    if (listItem) listItem.classList.remove("selected")

    this.updateSelectedDisplay()
    this.updateMemberInputs()
    this.updateSubmitButton()
  }

  updateMemberInputs() {
    let html = ""
    this.selectedMembers.forEach((name, id) => {
      html += `<input type="hidden" name="member_ids[]" value="${id}">`
    })
    this.memberInputsTarget.innerHTML = html
  }

  updateSubmitButton() {
    const nameInput = this.groupFormTarget.querySelector('input[name="name"]')
    const hasName = nameInput && nameInput.value.trim().length > 0
    const hasMembers = this.selectedMembers.size > 0

    this.submitBtnTarget.disabled = !(hasName && hasMembers)
  }
}
